module.exports = {
        srcSet: "https://static.sniffspot.com/packs/img/bp-6-128.fe05b93df065927d.jpg"+" 128w",
        images: [{path: "https://static.sniffspot.com/packs/img/bp-6-128.fe05b93df065927d.jpg",width: 128,height: 85}],
        src: "https://static.sniffspot.com/packs/img/bp-6-128.fe05b93df065927d.jpg",
        toString: function(){return "https://static.sniffspot.com/packs/img/bp-6-128.fe05b93df065927d.jpg"},
        
        width: 128,
        height: 85
      }